import { MissionsPanel } from '@juvare/missions/ui/features/missions-panel';
import { Box } from '@mui/material';
import React from 'react';
import { MissionProvider } from './providers';

export const MissionsPage: React.FC = () => {
    return (
        <Box sx={{ height: '100%', overflow: 'auto' }}>
            <MissionProvider>
                <MissionsPanel />
            </MissionProvider>
        </Box>
    );
};
